var render = function render(){var _vm=this,_c=_vm._self._c;return _c('a-descriptions',{attrs:{"bordered":"","title":"基本信息","size":"middle","column":2}},_vm._l((_vm.infoItems),function(item){return _c('a-descriptions-item',{key:item.key,attrs:{"label":item.label}},[_vm._v(_vm._s(item.value))])}),1)
}
var staticRenderFns = []

export { render, staticRenderFns }